<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">

import { getAssetsOrigin } from '~~/helpers/images/getAssetsOrigin';

/**
 * Product and CMS images are served from a separate host, so the browser has to
 * pay for DNS, TCP and TLS before the first image byte arrives. Warming that
 * connection while the document is still being parsed takes the handshake off
 * the critical path of the largest contentful paint.
 *
 * Declared here rather than through `app.head` in `nuxt.config.ts` so the
 * environment behind the origin is resolved per request instead of being baked
 * in at build time.
 */
useHead({
  link: [
    {
      rel: 'preconnect',
      href: getAssetsOrigin(),
    },
  ],
});

</script>
